<template>
    <div class="container">
        <!-- BOTTONI PRIMA DELLA MAPPA -->
        <div class="d-flex flex-wrap justify-content-center my-4 gap-3">
            <button class="btn btn-outline-primary" type="button" data-bs-toggle="collapse"
                    data-bs-target="#sezione2025">
                📅 Crimini Notizie BariToday/BariLive - 2025
            </button>
            <button class="btn btn-outline-primary" type="button" data-bs-toggle="collapse"
                    data-bs-target="#sezione2024">
                📅 Crimini Notizie BariToday/BariLive - 2024
            </button>
            <button class="btn btn-outline-primary" type="button" data-bs-toggle="collapse"
                    data-bs-target="#sezione10anni">
                📊 Crimini Notizie BariToday/BariLive - Ultimi 10 anni
            </button>
        </div>
    </div>

    <div v-if="loading" class="loading">
        <div class="loading-text">
            Caricamento...
        </div>
        <p class="spinner-border text-dark" role="status">
            <span class="visually-hidden">Loading...</span>
        </p>
    </div>
    <div v-else>
        <p class="container alert alert-info">
            ⬆️ Clicca sui tasti per visualizzare i dati relativi al 2025, 2024 e degli ultimi 10 anni ⬆️
        </p>
        <div id="crimesAccordion">
            <div v-if="df_current_year_dict" class="collapse show" id="sezione2025" data-bs-parent="#crimesAccordion">
                <div class="card card-body">
                    <div class="table-container">
                        <h2>🚑 Crimini: dati dell'anno 2025</h2>
                        <div v-for="(streets, area) in df_current_year_dict" :key="area" class="table-category">
                            <h3 class="text-primary">{{ area.substring(3) }}</h3>
                            <DataTable class="table table-bordered table-hover table-responsive pois-table"
                                       :options="this.options">
                                <thead>
                                <tr>
                                    <th v-for="key in columns" :key="key">
                                        {{ key }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(data, index) in streets" :key="index">
                                    <td v-for="key in columns" :key="key">
                                        {{ data[key] }}
                                    </td>
                                </tr>
                                </tbody>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
            <p v-else>Non ci sono dati disponibili.</p>

            <div v-if="df_last_year_dict" class="collapse" id="sezione2024" data-bs-parent="#crimesAccordion">
                <div class="card card-body">
                    <div class="table-container">
                        <h2>🚑 Crimini: dati dell'anno 2024</h2>
                        <div v-for="(streets, area) in df_last_year_dict" :key="area" class="table-category">
                            <h3 class="text-primary">{{ area.substring(3) }}</h3>
                            <DataTable class="table table-bordered table-hover table-responsive pois-table"
                                       :options="this.options">
                                <thead>
                                <tr>
                                    <th v-for="key in columns" :key="key">
                                        {{ key }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(data, index) in streets" :key="index">
                                    <td v-for="key in columns" :key="key">
                                        {{ data[key] }}
                                    </td>
                                </tr>
                                </tbody>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
            <p v-else>Non ci sono dati disponibili.</p>

            <div v-if="df_10_years_dict" class="collapse" id="sezione10anni" data-bs-parent="#crimesAccordion">
                <div class="card card-body">
                    <div class="table-container">
                        <h2>🚑 Crimini: ultimi 10 anni</h2>
                        <div v-for="(streets, area) in df_10_years_dict" :key="area" class="table-category">
                            <h3 class="text-primary">{{ area.substring(3) }}</h3>
                            <DataTable class="table table-bordered table-hover table-responsive pois-table"
                                       :options="this.options">
                                <thead>
                                <tr>
                                    <th v-for="key in columns" :key="key">
                                        {{ key }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(data, index) in streets" :key="index">
                                    <td v-for="key in columns" :key="key">
                                        {{ data[key] }}
                                    </td>
                                </tr>
                                </tbody>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
            <p v-else>Non ci sono dati disponibili.</p>
        </div>
    </div>
</template>

<script>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net';
import 'datatables.net-responsive';
import 'datatables.net-select';
import {useHead} from "@vueuse/head";

DataTable.use(DataTablesCore);


export default {
    components: {DataTable},
    setup() {
        useHead({
            title: 'InfoNav - Crimini'
        });
    },
    data() {
        return {
            loading: false,
            df_current_year_dict: [],
            df_10_years_dict: [],
            df_last_year_dict: [],
            options: {
                responsive: true,
                select: false,
                order: [[0, 'asc']],
                language: {
                    url: 'https://cdn.datatables.net/plug-ins/1.13.1/i18n/it-IT.json'
                }
            },
            columns: ["Posizione", "Strada", "Crimini", "Indice di criminalità"],
        }
    },
    methods: {
        async getData() {
            this.loading = true;
            await fetch('/api/crimes/', {
                method: 'GET',
            })
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        throw new Error('Error. Try again.');
                    }
                })
                .then((data) => {
                    this.df_current_year_dict = data['df_current_year_dict']
                    this.df_last_year_dict = data['df_last_year_dict']
                    this.df_10_years_dict = data['df_10_years_dict']
                })
                .catch((e) => {
                    console.error('Error fetching data:', e);
                })
                .finally(() => {
                    this.loading = false;
                })


        }
    },
    mounted() {
        // This function runs as soon as the component is loaded
        this.getData();
        // Initialize DataTable after the component has mounted

    },
}


</script>

<style scoped>
@import '../../../../node_modules/datatables.net-dt';

body {
    background-color: #f8f9fa;
    margin: 0;
    padding: 0;
}

/* Container */
.container {
    margin-top: 20px;
    padding: 0 15px;
    /* Aggiunto padding per migliorare la leggibilità */
}

/* Table Container */
.table-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
}

/* Table Styling */
.table thead th {
    background-color: #007bff;
    color: white;
    font-weight: bold;
    position: sticky;
    top: 0;
    z-index: 2;
}

.table tbody tr:nth-child(odd) {
    background-color: #f2f2f2;
}

.table-hover tbody tr:hover {
    background-color: #ddd;
}

/* Centratura dei titoli e delle tabelle */
h2 {
    text-align: center;
}

.loading {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.loading-text {
    margin-bottom: 1rem;
}

.alert {
    text-align: center;
}
</style>